import "@hotwired/turbo-rails"
import "./controllers"
import "./confirm"

// Move clouds to <html> on first load so Turbo never replaces them.
// On subsequent navigations, remove the freshly-rendered body copy.
// Move clouds to <html> on first load so Turbo never replaces them.
// On subsequent navigations, remove the freshly-rendered body copy.
document.addEventListener("DOMContentLoaded", () => {
  const clouds = document.getElementById("clouds-bg")
  if (clouds) document.documentElement.appendChild(clouds)
})

document.addEventListener("turbo:render", () => {
  const clouds = document.body.querySelector("#clouds-bg")
  if (clouds) clouds.remove()
})
